import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';
import Sticky from 'react-stickynode';
import styled from 'react-emotion';

import Style from '../../../../styles/common';

const Container = styled('h2')`
  mask-image: linear-gradient(rgba(0,0,0,1) 90%, rgba(0,0,0,0));
  background-color: ${Style.color.dateHeadingBackground};
  font-size: 1rem;
  margin: 0;
  padding: 2.5rem ${Style.SPACING.M};
`;

const Badge = styled('div')`
  background-color: ${Style.color.badgeBackground};
  border-radius: ${Style.BORDER_RADIUS};
  color: ${Style.color.badgeText};
  display: inline-block;
  margin-right: 1rem;
  padding: .5rem;
`;

const Title = styled('span')`
  font-size: 1.15rem;
`;

function EventDateTitle(props) {
  const top = Style.MEASUREMENT.MASTHEAD.HEIGHT + Style.MEASUREMENT.CATEGORY_NAV.HEIGHT;

  return (
    <Sticky top={top} innerZ={10}>
      <Container>
        <Badge>{moment(props.date).format('D')}</Badge>
        <Title>{moment(props.date).format('dddd, MMMM D')}</Title>
      </Container>
    </Sticky>
  );
}

EventDateTitle.propTypes = {
  date: PropTypes.string.isRequired,
  offset: PropTypes.number,
};

EventDateTitle.defaultProps = {
  offset: 0,
};

export default EventDateTitle;



// WEBPACK FOOTER //
// ./src/views/Browse/Events/EventDateTitle/EventDateTitle.js